'use client';

import { type ConsentPreferences } from './types';

export function ConsentModeScript() {
  return (
    <script
      id="consent-mode-default"
      dangerouslySetInnerHTML={{
        __html: `
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function(){window.dataLayer.push(arguments);};
window.gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'personalization_storage': 'denied',
  'functionality_storage': 'granted',
  'security_storage': 'granted',
  'wait_for_update': 500
});
`,
      }}
    />
  );
}

export const updateConsentMode = (preferences: Partial<ConsentPreferences>) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag('consent', 'update', preferences);
};

export function initConsentListening() {
  if (typeof window === 'undefined') return;

  const processUpdate = (type: 'analytics' | 'marketing', granted: boolean) => {
    if (type === 'analytics') {
      if (granted) {
        updateConsentMode({
          analytics_storage: 'granted',
          personalization_storage: 'granted',
        });
      } else {
        updateConsentMode({
          analytics_storage: 'denied',
          personalization_storage: 'denied',
        });
      }
    } else if (type === 'marketing') {
      if (granted) {
        updateConsentMode({
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
        });
      } else {
        updateConsentMode({
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
      }
    }
  };

  const queue = window.postbrixConsentQueue || [];

  window.postbrixUpdateConsent = (type, granted) => {
    void processUpdate(type, granted);
  };

  queue.forEach((item) => {
    void processUpdate(item.type, item.granted);
  });

  window.postbrixConsentQueue = [];

  const silktide = (window as any).silktideConsentManager;
  if (silktide && typeof silktide.getConsent === 'function') {
    const analyticsConsent = silktide.getConsent('analytics');
    const marketingConsent = silktide.getConsent('marketing');
    if (analyticsConsent) window.postbrixUpdateConsent('analytics', true);
    if (marketingConsent) window.postbrixUpdateConsent('marketing', true);
  }
}
